import { AppContext } from 'App'
import React, { useContext } from 'react'
import { Tab } from 'static/tabs'
import { FormContext } from 'components/utils/Form.context'
import { Form as FormHelper } from 'helpers/form'
import { Routing as RoutingHelper } from 'helpers/routing'
import { Reload as ReloadHelper } from 'helpers/reload'
import { Data as DataHelper } from 'helpers/data'
import Accordion from 'components/utils/Accordion/Accordion'
import Container from 'components/utils/GridContainer/GridContainer'
import CTAButton from 'components/utils/Button/CTAButton'
import Table from './Table'
import ReloadButton from 'components/utils/Button/ReloadButton'
import { MatchContext } from 'components/Matches/__Matches.context'

const TableWithAdd: React.FC = () => {
  const { db, alert } = useContext(AppContext)
  const { params: m_params } = useContext(MatchContext)

  const opt = {
    alert: {
      manager: alert,
      texts: {
        form: Tab.MatchDatasourceIdentifiers,
      },
    },
  }

  const touchAll = async () => {
    if (!db?.matchDatasourceIdentifiers) return

    await FormHelper.touchAll({
      repository: db.matchDatasourceIdentifiers,
      optional: opt,
    })
  }

  const reload = async () => {
    if (!db?.matchDatasourceIdentifiers) return

    if (m_params?.match_id)
    return await ReloadHelper.reload({
      getAllFn: () => DataHelper.getMatchDatasourceIdentifiersByMatchId(
        db,
        m_params.match_id
      ),
      optional: opt
    })
  }

  const computeRoutingPath = () => {
    const _routingParams = {
      matchDatasourceIdentifier: RoutingHelper.NewRecordSymbol,
      match: m_params?.match_id ?? RoutingHelper.NewRecordSymbol,
      tournament: m_params?.tournament_id ?? RoutingHelper.NewRecordSymbol
    }

    if (m_params?.match_id)
      return RoutingHelper.getMatchDatasourceIdentifierUrlFromMatch(
        _routingParams
      )
  }

  return (
    <FormContext.Provider value={{ touch: touchAll }}>
      <Accordion
        content={
          <Container
            items={[
              <CTAButton
                key={'Container.CTA_New'}
                path={computeRoutingPath()}
              >
                New
              </CTAButton>,
              <ReloadButton
              key={'Container.RealoadButton'}
              reloadFn={reload}
              from={opt.alert.texts.form}
            />
          ]}
          />
        }
        toggle={<Table />}
      />
    </FormContext.Provider>
  )
}

export default TableWithAdd
